var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-card', {
    staticClass: "chart-card",
    style: _vm.chartStyle,
    attrs: {
      "shadow": "hover"
    },
    scopedSlots: _vm._u([_vm.isShowTitle ? {
      key: "header",
      fn: function () {
        return [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm.showTip && _vm.tip ? [_c('el-tooltip', {
          attrs: {
            "effect": _vm.tipEffect,
            "content": _vm.tip,
            "placement": _vm.tipPlacement
          }
        }, [_c('i', {
          staticClass: "el-tooltip el-icon-question"
        })])] : _vm._e()];
      },
      proxy: true
    } : null], null, true)
  }, [_c('res-chart', _vm._g({
    attrs: {
      "init-options": _vm.initOptions,
      "option": _vm.option,
      "theme": "res-echarts-theme"
    }
  }, _vm.$listeners))], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };